import { AxiosTencerAdminApiClient } from 'app/shared/infrastructure/api/AxiosTencerAdminApiClient';
import { ProductSyncRepository } from 'app/modules/settings/domain/repository/ProductSyncRepository';
import { ProductSyncStatus } from 'app/modules/settings/domain/entity/ProductSyncStatus';
import { ProductSyncStatusMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/ProductSyncStatusMapper';
import { SpecificSyncStatusList } from 'app/modules/settings/domain/aggregate/SpecificSyncStatusList';
import { SpecificSyncStatusMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/SpecificSyncStatusMapper';

export class ApiProductSyncRepository implements ProductSyncRepository {

    constructor(private _apiClient: AxiosTencerAdminApiClient) {}

    public async findAll(syncCommand: string): Promise<ProductSyncStatus[]> {
        const response = await this._apiClient.fetchGetProductSyncStatus(syncCommand);
        return ProductSyncStatusMapper.toDomainArray(response.data);
    }

    public async sync(syncCommand: string): Promise<void> {
        await this._apiClient.fetchPostProductSync(syncCommand);
    }

    public async findAllSpecific(
        limit: number,
        offset: number,
    ): Promise<SpecificSyncStatusList> {
        const response = await this._apiClient.fetchGetSpecificSyncStatus(limit, offset);
        return new SpecificSyncStatusList(
            SpecificSyncStatusMapper.toDomainArray(response.data.items),
            response.data.total_records,
        );
    }

    public async syncProduct(productId: string): Promise<void> {
        await this._apiClient.fetchPostSyncProduct(productId);
    }

    public async syncErpCode(erpCode: string): Promise<void> {
        await this._apiClient.fetchPostSyncErpCode(erpCode);
    }

}
